import { nestedNodeDelimiter, LayoutRules } from "@buildwithflux/models";
import { humanizeLengthValue } from "@buildwithflux/shared";
import { PcbNodeHelper } from "../../../nodes";
/**
 * Extracts the importing element ID from a node ID by splitting on the nested node delimiter
 * and returning the first part. If the node is not under a sub-layout or if the split
 * operation results in an undefined value, returns null.
 *
 * @param nodeId - The node ID to extract the importing element ID from
 * @returns The importing element ID or null if not found or invalid
 */
export const getImportingElementId = (nodeId) => {
    if (!PcbNodeHelper.isNodeUnderSubLayout(nodeId)) {
        return null;
    }
    return nodeId.split(nestedNodeDelimiter).at(0) ?? null;
};
/**
 * Gets the existing node ID from a potentially nested node ID.
 *
 * For nodes that are not under a sublayout, returns the original nodeId.
 * For nodes under a sublayout, extracts and returns the last segment after
 * splitting by the nested node delimiter, which represents the actual node ID.
 *
 * @param nodeId - The node ID to process, which may contain nested delimiters
 * @returns The existing node ID, or the original nodeId if extraction fails
 */
export const getExistingNodeId = (nodeId) => {
    if (!PcbNodeHelper.isNodeUnderSubLayout(nodeId)) {
        return nodeId;
    }
    // Return the last ID as we could be under a sublayout
    return nodeId.split(nestedNodeDelimiter).pop() ?? nodeId;
};
/**
 * Create a position rule based on current mouse position on canvas.
 * In this function we will ensure the position is relative to top level layout, if there is one.
 *
 */
export const createRuleSetWithPositionForExistingNodeFromSceneMousePosition = (sceneMousePosition, node, parentNode) => {
    if (!sceneMousePosition || !node) {
        return {};
    }
    const positionRule = createPositionRuleFromScenePosition(sceneMousePosition, node.bakedRules.unit, parentNode);
    return { [positionRule.key]: positionRule };
};
export function createPositionRuleFromScenePosition(scenePosition, unit, parentNode) {
    const relativePosition = parentNode
        ? PcbNodeHelper.scenePositionToNodeSpace(scenePosition, parentNode)
        : scenePosition;
    const xPositionValue = humanizeLengthValue(relativePosition.x, unit);
    const yPositionValue = humanizeLengthValue(relativePosition.y, unit);
    return {
        uid: "position",
        key: LayoutRules.position.key,
        value: `${xPositionValue} ${yPositionValue}`,
        disabled: false,
    };
}
//# sourceMappingURL=PcbLayoutHelpers.js.map